import React, { useState, useEffect, createContext, useContext } from "react";
import { useAuth } from "../hooks/useAuth";
import { useUser, UserType } from "../hooks/useUser";
import { useLocalStorage } from "../hooks/useLocalStorage";

/* type Props = {
    children?: ReactNode;
}

type IAuthContext = {
    isLoggedIn: boolean;
    setIsLoggedIn: (newSate: boolean) => void;
    authUser: any;
    setAuthUser: (newSate: boolean) => void;
}

const initialValue = {
    isLoggedIn: false,
    setIsLoggedIn: () => { },
    authUser: null,
    setAuthUser: () => { },
}

export type AuthContextType = {
    user: UserType | null;
    login: (email: string, password: string)=> void;
    isAuthenticated: boolean;
}*/

//export const AuthContext = createContext<AuthContextType | null>(null!);

export const AuthContext = createContext(undefined);

//export const AuthContextProvider: React.FC<{children: ReactNode}> = ({children}: any) => {
export const AuthProvider = (props) => {

    const { login, logout, isAuthenticated, user, role, roles, userId, token } = useAuth(); //POR AHORA acceder desde el hook useAuth
    const { getItem, removeItem } = useLocalStorage();

    const { children } = props;

    // Señal para evitar parpadeos: esperamos a que termine el chequeo inicial
    const [authReady, setAuthReady] = useState(false);

    useEffect(() => {
        let isMounted = true;
        const ENABLE_SERVER_VERIFY = true; // Cambiar a false si no querés intentar la verificación por backend aún

        const checkAuthenticated = async () => {
            try {
                const rawToken = getItem("token");
                const rawUser = getItem("user");
                const rawRole = getItem("role");
                const rawUserId = getItem("userId");
                const rawRoles = getItem("roles"); //multi-rol (074)

                let token = null;
                let storedUser = null;
                let storedRole = null;
                let storedUserId = null;
                let storedRoles = null;

                try {
                    token = rawToken && rawToken !== '' ? JSON.parse(rawToken) : null;
                } catch (e) {
                    console.warn('Invalid token in storage');
                    removeItem('token');
                }
                try {
                    storedUser = rawUser && rawUser !== '' ? JSON.parse(rawUser) : null;
                } catch (e) {
                    console.warn('Invalid user in storage');
                    removeItem('user');
                }
                try {
                    storedRole = rawRole && rawRole !== '' ? JSON.parse(rawRole) : null;
                } catch (e) {
                    console.warn('Invalid role in storage');
                    removeItem('role');
                }
                try {
                    storedUserId = rawUserId && rawUserId !== '' ? JSON.parse(rawUserId) : null;
                } catch (e) {
                    console.warn('Invalid userId in storage');
                    removeItem('userId');
                }
                try {
                    storedRoles = rawRoles && rawRoles !== '' ? JSON.parse(rawRoles) : null;
                } catch (e) {
                    console.warn('Invalid roles in storage');
                    removeItem('roles');
                }

                // Multi-rol (074): los usuarios que ya tenían sesión guardada NO
                // tienen el key "roles" en localStorage (se agregó recién ahora).
                // Para ellos la lista es [role], que es exactamente lo que les
                // tocaba antes. Sin este fallback, una sesión preexistente se
                // hidrata con roles = null y el usuario no recibe ni un aviso.
                if (token && Array.isArray(storedRoles) === false) {
                    storedRoles = storedRole ? [storedRole] : [];
                }

                if (token) {
                    // Guarda contra el logout durante la verificación: si el token
                    // local ya no es EL MISMO que capturamos al arrancar (se borró por
                    // un logout o se reemplazó por un refresh), la respuesta del
                    // /verify llega tarde y NO se puede re-hidratar: escribiría de
                    // nuevo la sesión que el usuario quiso cerrar. Este era el bug:
                    // checkAuthenticated corría en cada render (deps inestables) y un
                    // verify en vuelo durante el logout resucitaba la sesión.
                    const elTokenSigueSiendo = (capturado) => {
                        const raw = getItem("token");
                        let actual = null;
                        try {
                            actual = raw && raw !== '' ? JSON.parse(raw) : null;
                        } catch {
                            actual = null;
                        }
                        return actual === capturado;
                    };

                    if (ENABLE_SERVER_VERIFY) {
                        try {
                            const res = await fetch('/api/authentication/verify', {
                                method: 'GET',
                                headers: {
                                    'Authorization': `Bearer ${token}`,
                                    'Content-Type': 'application/json'
                                }
                            });

                            if (res.ok) {
                                if (!elTokenSigueSiendo(token)) {
                                    console.warn('[authContext] Token se borró o cambió durante la verificación; no se hidrata');
                                    return;
                                }
                                // Si el backend confirma, hidratamos el contexto
                                login(storedUser, token, storedRole, storedUserId, storedRoles);
                            } else {
                                // Si el backend rechaza, no autenticamos (se mantendrá isAuthenticated=false)
                                // Podés llamar a logout() si querés limpiar inmediatamente el storage
                                // logout();
                                console.warn('Token rechazado por /api/authentication/verify');
                            }
                        } catch (err) {
                            if (!elTokenSigueSiendo(token)) {
                                console.warn('[authContext] Token se borró o cambió durante la verificación; no se hidrata');
                                return;
                            }
                            // El endpoint aún no existe: dejamos preparado, pero no bloqueamos el flujo
                            console.warn('No se pudo verificar el token. Continuando con token local...', err);
                            // Elegimos hidratar igual para mantener la UX; cuando esté el endpoint se validará en serio
                            login(storedUser, token, storedRole, storedUserId, storedRoles);
                        }
                    } else {
                        // Verificación deshabilitada: confiamos en el token almacenado
                        login(storedUser, token, storedRole, storedUserId, storedRoles);
                    }
                } else {
                    // No hay token en storage: aseguramos estado listo sin autenticación
                    // logout(); // opcional: limpiar cualquier rastro
                }
            } finally {
                if (isMounted) setAuthReady(true);
            }
        };

        checkAuthenticated();
        return () => { isMounted = false; };
    }, [getItem, login]);

    // Valor del contexto (incluye authReady)
    const value = { login, logout, isAuthenticated, user, role, roles, userId, authReady, token } //prueba

    /* const cambioAuth = (auth: boolean) => {
        if(auth === false){
            setIsAuthenticated(false)
        } else {
            setIsAuthenticated(true)
        }
    } */

    return (
        <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
    )
}

//export { AuthContextProvider};



//{/*asi da error  */}
//{/* <SessionContext.Provider value={defaultValue}>{children}</SessionContext.Provider> */}

//React.createElement(SessionContext.Provider, {value: defaultValue}, children)